/**
 * If supplied with anything other than a function, a no-op function is returned. Given a function, the same
 * is returned.
 *
 * @param {function|undefined} func The function to check.
 * @return {function} The supplied function, or a function that does nothing if undefined was supplied.
 */
function undefinedToNoOp(func) {
    return typeof func === 'function' ? func : function () {};
}

/**
 * Takes a callback function and sets a timeout after which it is executed, unless the returned function is
 * called first.
 *
 * No matter how often the returned function is called, the callback will only ever execute once.
 *
 * @param {function} callback Function to call once the timeout has expired, or the returned function has been
 *      called.
 * @param {int} timeout Milliseconds after which the callback should be called the latest.
 * @return {function} If this is called, timeout is aborted and the callback is called immediately. If the
 *      timeout completed before this function is called, nothing happens because the original callback has
 *      already been triggered once.
 */
function wrapCallbackWithTimeout(callback, timeout) {
    let callbackCalled = false;

    const timeoutHandle = setTimeout(function () {
        callbackCalled = true;
        callback();
    }, timeout);

    return function () {
        clearTimeout(timeoutHandle);

        if (!callbackCalled) {
            callbackCalled = true;
            callback();
        }
    };
}

export default {
    undefinedToNoOp: undefinedToNoOp,
    wrapCallbackWithTimeout: wrapCallbackWithTimeout,
};
